import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  XtpXdpConnectionProtocol,
  XtpXdpConnectionMenuActionsType,
} from 'data/xtp-xdp-connection/xtp-xdp-connection.types';
import './xtp-xdp-action-menu.scss';

type Props = {
  selectedItem?: XtpXdpConnectionProtocol;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: ()=> void;
  onDelete: ()=> void;
}

const XtpXdpGridActionMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="XtpXdpGridActionMenu" className="xtp-xdp-action-menu">
      {hasPrivilegesToCreate && (
      <Button
        className="xtp-xdp-action-menu-button"
        style={{ marginRight: '0.8rem' }}
        data-testid={`${XtpXdpConnectionMenuActionsType.Edit}-button`}
        text={t('common.grid.edit')}
        onClick={onEdit}
      />
      )}
      {hasPrivilegeToDelete && (
      <Button
        className="xtp-xdp-action-menu-button"
        data-testid={`${XtpXdpConnectionMenuActionsType.Delete}-button`}
        text={t('common.grid.delete')}
        onClick={handleOpenDeleteDialog}
      />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('xtpXdpConnection.deletePopup.title')}
        displayMessage={
          t('xtpXdpConnection.deletePopup.message', { name: selectedItem.name })
        }
        actionText={t('common.button.confirmDelete')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default XtpXdpGridActionMenu;
